import { Card, Stack } from '@heathmont/moon-components';
import { Caption, Text } from '@heathmont/moon-core';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import Translate from '~/client/shared/i18n/Translate';
import Img from '~/client/shared/images/Img';
import InlineStack from '~/client/shared/InlineStack';
import NextLink from '~/client/shared/NextLink';
import LightThemeProvider from '~/client/shared/ThemeProviders/LightThemeProvider';
import { CDN_IMG_URL } from '~/shared/cdn/url';

type Props = {
  name: string;
  handle: string;
  count: number;
  sendToGtm: () => void;
};

const ProvidersMobileContainer = styled(InlineStack)`
  height: ${rem(80)};
  span {
    align-self: flex-end;
  }
  a {
    display: grid;
  }
`;

const ProviderCard = styled(Card)`
  && {
    display: grid;
    align-items: center;
    height: ${rem(80)};
    min-height: ${rem(80)};
    img {
      max-height: ${rem(50)};
    }
  }
`;

const ProviderCardMobile: FC<Props> = ({ name, handle, count, sendToGtm }) => (
  <ProvidersMobileContainer
    templateColumns={`${rem(152)} auto`}
    gridGap={rem(12)}
  >
    <LightThemeProvider>
      <ProviderCard template="front">
        <NextLink href={`/providers/${handle}`}>
          <Img
            src={`${CDN_IMG_URL}/providers/${handle}.svg`}
            alt={name}
            width={102}
            onClick={sendToGtm}
          />
        </NextLink>
      </ProviderCard>
    </LightThemeProvider>
    <Stack space="xsmall">
      <NextLink
        prefetch={false}
        href={`/providers/${handle}`}
        onClick={sendToGtm}
      >
        <>
          <Caption color={'trunks.100'} as="span">
            <Translate id="casino.games_count" values={{ count }} />
          </Caption>
          <Text as="h4" size={14} isBold color={'bulma.100'}>
            {name}
          </Text>
        </>
      </NextLink>
    </Stack>
  </ProvidersMobileContainer>
);

export default ProviderCardMobile;
